var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit"},[_c('header-nav',{attrs:{"current":_vm.current}}),_c('div',{ref:"content",staticClass:"content"},[_c('div',{staticClass:"box clearfix"},[_c('user-left',{attrs:{"name":'case'}}),_c('div',{ref:"right",staticClass:"user-right"},[_vm._m(0),_c('div',{})])],1)]),_c('footer-nav')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-top"},[_c('strong',[_vm._v("案例轨迹")])])
}]

export { render, staticRenderFns }